import styled from 'styled-components'
import { backgroundOrange, darkOrange, gold, black, warmTint } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export { Button } from '@components/Button'

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const SummaryCard = styled.div`
    background: ${backgroundOrange};
    border: 1px solid ${warmTint};
    border-radius: ${radii.inner};
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 12px;
`

export const SummaryAvatars = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
`


export const SummaryArrow = styled.span`
    color: ${darkOrange};
    font-size: ${fontSizes.title};
    font-weight: 700;
`

export const SummaryName = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${black};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const SummaryAmount = styled.span`
    font-size: ${fontSizes.body};
    font-weight: 700;
    color: ${darkOrange};
    flex-shrink: 0;
`

export const SummaryCurrencyCode = styled.span`
    font-size: ${fontSizes.micro};
    color: ${gold};
    margin-left: 4px;
`

export const ConfirmText = styled.p`
    margin: 0;
    font-size: ${fontSizes.base};
    color: ${black};
    line-height: ${leading.body};
`

export const CrossUserWarning = styled.div`
    font-size: ${fontSizes.caption};
    color: ${darkOrange};
    background: ${gold}1f;
    border: 1px solid ${gold}66;
    padding: 10px 14px;
    border-radius: ${radii.small};
    line-height: ${leading.body};
`

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 8px;
`

